export default "__VITE_ASSET__Bqv4hmdR__"